import React from 'react';
import { Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ARCHETYP_OHNE_ZUORDNUNG } from '../utils/helpers';

/**
 * Archetyp-Chips ueber der Katalogliste (#788).
 *
 * `archetypes` ist bereits die vollstaendige, gemergte Liste: jeder Archetyp,
 * den es in dieser Stellung ueberhaupt gibt (auch mit Anzahl 0 unter den
 * aktuell aktiven Filtern, AK5), plus der Bucket "ohne Zuordnung" (`value:
 * ''`) am Ende. Das Mergen selbst -- Vollbestand plus gefilterte Zaehlung --
 * ist Sache von DataCatalog.js, nicht dieser Darstellungskomponente.
 */
const ArchetypChips = ({ archetypes, selectedArchetype, onToggle }) => {
  const { t } = useTranslation();

  if (!archetypes || archetypes.length === 0) {
    return null;
  }

  return (
    <Box
      data-testid="archetyp-chips"
      sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}
    >
      {archetypes.map(({ value, count }) => {
        // `"keiner"` ist der serverseitige Sonderwert (#788), nicht ein
        // Archetypbezeichner -- er bekommt eine lesbare Beschriftung, geht
        // als Filterwert aber unveraendert zurueck.
        const ohneZuordnung = !value || value === ARCHETYP_OHNE_ZUORDNUNG;
        const beschriftung = ohneZuordnung
          ? t('dataCatalog.openehr.archetypOhneZuordnung')
          : value;
        const aktiv = selectedArchetype === value;

        return (
          <Chip
            key={value || '__ohne_zuordnung__'}
            data-testid={`archetyp-chip-${ohneZuordnung ? 'ohne-zuordnung' : value}`}
            label={`${beschriftung} ${count}`}
            onClick={() => onToggle(value)}
            color={aktiv ? 'primary' : 'default'}
            variant={aktiv ? 'filled' : 'outlined'}
            size="small"
          />
        );
      })}
    </Box>
  );
};

export default ArchetypChips;
